import { css } from "@emotion/react";
import { Theme } from "@mui/material";

export const menuStateIconStyles = {
  burgerWrapper: (theme: Theme) =>
    css({
      width: 24,
      height: 24,
      ".hamburger-icon": {
        fontSize: 24,
      },
      ".hamburger-box": {
        marginBottom: 4,
      },
      ".hamburger-inner, .hamburger-inner::before, .hamburger-inner::after": {
        background: `${theme.palette.text.primary}`,
        "@media (forced-colors: active) and (prefers-color-scheme: dark)": {
          forcedColorAdjust: "none",
          background: `${theme.palette.text.primary}`,
        },
        "@media (forced-colors: active) and (prefers-color-scheme: light)": {
          forcedColorAdjust: "none",
          background: `${theme.palette.common.black}`,
        },
      },
    }),
};
